module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AgreementList'
      }
    }
  }, [_vm._v("Umowy")]), _vm._v("/Nowa umowa\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.isLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    ref: "tabs",
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Dane podstawowe",
      "active": ""
    }
  }, [_c('AgreementFormGeneral', {
    attrs: {
      "handle-submit": _vm.create,
      "errors": _vm.violations,
      "values": _vm.item
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Faktury",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Dokumenty",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Zaliczki, Potrącenia, Zwroty",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Rozliczenie umowy",
      "disabled": "disabled"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-258feb3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/Create.vue
// module id = 797
// module chunks = 0